import React, { Component } from 'react';
import { Modal, Button, Icon, InputNumber, Table, Spin, message } from 'antd';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';

class PlanFteAllocation extends Component {
    state = {
        data: [],
        visible: false,
        loading: false,
        canEdit: false,
        managePlanFteRatio: 0,
    }

    show = () => {
        this.setState({
            visible: true,
        }, () => {
            this.loadData();
            this.queryInvManagePlanFteRatio();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            data: [],
        });
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.plan.queryInvestigationManagePlanFte,
            data: { },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.managePlanFteList,
                    loading: false,
                });
            }
        }
        $.sendRequest(options)
    }

    queryInvManagePlanFteRatio = () => {
        const options = {
            method: 'POST',
            url: API_URL.plan.queryInvManagePlanFteRatio,
            data: { },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    managePlanFteRatio: res.managePlanFteRatio,
                })
            }
        };
        $.sendRequest(options);
    }

    renderUserRow = (value, rowSpan) => {
        const obj = {
            children: value ? value : '-',
            props: {
                rowSpan,
            },
        };
        return obj
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'sortNum',
        key: 'sortNum',
        width: 60,
    }, {
        title: '承担的项目角色',
        dataIndex: 'roleCodeShow',
        key: 'roleCodeShow',
        render: (text, record) => this.renderUserRow(text, record.rowSpan)
    }, {
        title: '项目计划FTE分配比例（%）',
        dataIndex: 'fteAllocationRation',
        key: 'fteAllocationRation',
        render: (text, record) => this.renderUserRow(`${text}%`, record.rowSpan)
    }, {
        title: '一级细项',
        dataIndex: 'childRoleCodeShow',
        key: 'childRoleCodeShow',
    }, {
        title: '项目计划FTE分配占比',
        dataIndex: 'childFteAllocationRation',
        key: 'childFteAllocationRation',
    }];

    getDataSource = () => {
        const dataSource = [];
        const { data } = this.state;
        data.map((el) => {
            if (el.childList) {
                (el.childList || []).map((child, childIndex) => {
                    dataSource.push({
                        roleCodeShow: el.roleCodeShow,
                        fteAllocationRation: el.fteAllocationRation,
                        id: child.id,
                        childRoleCodeShow: child.roleCodeShow,
                        childFteAllocationRation: child.fteAllocationRation,
                        rowSpan: childIndex ? 0 : el.childList.length,
                    });
                })
            } else {
                dataSource.push({
                    ...el,
                    childRoleCodeShow: '-',
                    childFteAllocationRation: '-',
                });
            }
            
        });
        dataSource.map((el, index) => el.sortNum = index + 1);
        return dataSource;
    }

    save = () => {
        const { managePlanFteRatio } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.plan.updateInvManagePlanFteRatio,
            data: { ratio: managePlanFteRatio },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    canEdit: false,
                    loading: false,
                });
                this.props.reload();
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value) => {
        this.setState({ managePlanFteRatio: value });
    }

    render() {
        const { visible, loading, managePlanFteRatio, canEdit } = this.state;
        const { isInvAreaLeader, isInvPM } = sessionStorage;
        return (
            <Modal
                title="项目管理计划FTE自动分配规则"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="700px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                <div className="cont-cont contract-record" style={{ margin: 20 }}>
                    <div style={{ marginBottom: 15 }}>
                        项目管理计划FTE=项目管理计划FTE占比*合同FTE
                    </div>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 15
                    }}>
                        项目管理计划FTE占比：
                        {
                            canEdit ? <InputNumber
                                placeholder='请输入'
                                step={0.01}
                                min={0}
                                precision={2}
                                style={{ width: 80 }}
                                value={managePlanFteRatio}
                                onChange={value => this.handleChange(value, 'managePlanFteRatio')}
                            />
                                : managePlanFteRatio
                        }
                        {(isInvAreaLeader == 'true' || isInvPM == 'true') &&
                            (canEdit ? <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: 40,
                                justifyContent: 'space-between',
                                marginLeft: 10,
                            }}>
                                <Icon
                                    type="check"
                                    style={{ color: 'green', cursor: 'pointer', fontSize: 18 }}
                                    onClick={() => this.save()}
                                />
                                <Icon
                                    type="close"
                                    style={{ color: 'red', cursor: 'pointer', fontSize: 18 }}
                                    onClick={() => this.setState({ canEdit: false })}
                                />
                            </div> : <a>
                                <Icon
                                    type="edit"
                                    style={{ fontSize: 15, marginLeft: 10 }}
                                    onClick={() => this.setState({ canEdit: true })}
                                />
                            </a>)
                        }

                    </div>
                    <div>
                        各项目角色分配情况：
                        <Table
                            bordered
                            rowKey={record => record.id}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            pagination={false}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
                </Spin>
                
            </Modal>
        );
    }
}

export default PlanFteAllocation;


// WEBPACK FOOTER //
// ./src/components/plan/PlanFteAllocation.js